import React from 'react';
export function DetailedSection() {
  return <div className="max-w-3xl mx-auto px-5 md:px-6 py-10" data-id="element-57">
      <hr className="border-t-2 border-dashed border-border-light mb-10" data-id="element-58" />

      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-6" data-id="element-59">
        Actividades Tan Detalladas... ¡Que Prácticamente Se Hacen Solas!
      </h2>

      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-60">
        Todas las actividades vienen con guías tan detalladas que{' '}
        <strong data-id="element-61">no hay lugar para la improvisación</strong>.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-62">
        He visto cantidad de recursos e "instrucciones" por ahí...
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-63">
        ...y después de revisarlos, no me sorprende que tantas madres y padres
        excepcionalmente dedicados — personas talentosas como TÚ — simplemente{' '}
        <strong data-id="element-64">se rindan</strong> después de intentarlo.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-65">
        Algunos son solo un par de imágenes bonitas de Pinterest... y luego se
        espera que descifres todo lo demás por tu cuenta.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-66">
        Sin pasos claros, sin explicación de los beneficios, sin lista de
        materiales. Solo un <em data-id="element-67">"buena suerte"</em> y ya.
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-68">
        El <strong data-id="element-69">Pack Estimulación Temprana</strong> te da el{' '}
        <span className="highlight" data-id="element-70">"paquete completo"</span> de instrucciones y
        recursos para que lo hagas bien A LA PRIMERA... y para evitar toda la
        confusión y la frustración.
      </p>

      <p className="font-serif text-lg text-body-text mb-3 leading-relaxed" data-id="element-71">
        <strong data-id="element-72">No importa cuál sea tu experiencia.</strong>
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-73">
        Este pack hace que sea fácil completar actividades de estimulación
        significativas... sin importar si eres primerizo/a o si ya tienes años
        de experiencia criando hijos.
      </p>

      <p className="font-serif text-lg text-body-text mb-3 leading-relaxed" data-id="element-74">
        <strong data-id="element-75">No importa cuál sea tu presupuesto.</strong>
      </p>
      <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-76">
        La mayoría no aprovechamos el potencial de estimulación porque creemos
        que va a costar una fortuna. Pero aquí descubrirás que los mejores
        estímulos se logran con lo que YA TIENES en casa.
      </p>

      <p className="font-serif text-lg text-body-text mb-3 leading-relaxed" data-id="element-77">
        <strong data-id="element-78">No importa si no tienes mucho tiempo.</strong>
      </p>
      <p className="font-serif text-lg text-body-text mb-8 leading-relaxed" data-id="element-79">
        Quizás tu día es un caos entre trabajo, casa y mil cosas más — y eso
        está perfectamente bien. Con solo <strong data-id="element-80">10 minutos al día</strong>{' '}
        puedes hacer una diferencia real en el desarrollo de tu hijo/a.
      </p>

      <hr className="border-t-2 border-dashed border-border-light my-10" data-id="element-81" />

      {/* Everything You Get Box */}
      <h2 className="font-serif text-2xl md:text-3xl font-bold text-dark text-center mb-6" data-id="element-82">
        Esto Es TODO Lo Que Recibes Con El Pack:
      </h2>

      <div className="bg-gradient-to-br from-[#FFF8E1] to-highlight-bg border-[3px] border-green rounded-2xl py-9 px-6 md:px-8 text-left my-8" data-id="element-83">
        <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-84">
          ✅ <strong data-id="element-85">+1.000 Actividades "Hechas Para Ti"</strong>
          <br data-id="element-86" />
          <span className="text-base text-gray-600" data-id="element-87">
            Descarga más de 1.000 actividades organizadas mes a mes con
            instrucciones paso a paso, materiales simples y el área de
            desarrollo que trabaja cada una. Desde recién nacidos hasta los 5
            años, TODO está cubierto.
          </span>
        </p>

        <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-88">
          ✅ <strong data-id="element-89">Guías en PDF Imprimibles</strong>
          <br data-id="element-90" />
          <span className="text-base text-gray-600" data-id="element-91">
            Imprime las guías y ten todo a mano. Sin necesidad de pantallas
            durante las actividades. Accede desde cualquier dispositivo, en
            cualquier momento.
          </span>
        </p>

        <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-92">
          ✅ <strong data-id="element-93">Estimulación de Mente y Cuerpo Desde Casa</strong>
          <br data-id="element-94" />
          <span className="text-base text-gray-600" data-id="element-95">
            Ejercicios diseñados para trabajar motricidad, lenguaje, cognición,
            sensorialidad y desarrollo socioemocional. Todo desde la comodidad
            de tu hogar.
          </span>
        </p>

        <p className="font-serif text-lg text-body-text mb-5 leading-relaxed" data-id="element-96">
          ✅{' '}
          <strong data-id="element-97">Saber Exactamente Qué Necesita Tu Hijo Según Su Edad</strong>
          <br data-id="element-98" />
          <span className="text-base text-gray-600" data-id="element-99">
            Sin buscar más en internet. Sin dudar. Abre la guía del mes
            correspondiente y ya sabes qué hacer HOY.
          </span>
        </p>

        <p className="font-serif text-lg text-body-text leading-relaxed" data-id="element-100">
          ✅ <strong data-id="element-101">Garantía de Satisfacción 100% Sin Riesgo</strong>
        </p>
      </div>
    </div>;
}